import React from "react";

const PrimaryButton = ({ label, className, onClick, type, disabled, variant }) => {
  const isWhiteBg = typeof className === 'string' && (className.includes('bg-white') || variant === 'outline');
  const baseBg = disabled ? "bg-[#D9D9D9] cursor-not-allowed" : (isWhiteBg ? "" : "bg-[#00ADEF]");
  const baseText = isWhiteBg ? "" : "text-white";
  return (
    <button
      type={type ? type : "button"}
      className={`${baseBg} ${baseText} font-poppins text-center ${className ? className : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default PrimaryButton;
